<template>
    <a class="wdmota-tower-card" :href="`/backend/wdtower/linkto.php?name=${ tower.name }`" target="_blank">
        <img class="cover" :src="tower.image" />
    </a>
</template>

<script>
export default {
    props: [ 'tower' ],
    components: {

    }
}
</script>

<style lang="less" scoped>
.wdmota-tower-card {
    position: relative;
    display: block;

    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);

    margin-bottom: 12px;
    margin-left: 1%;
    margin-right: 1%;

    height: 240px;
    width: 98%;

    @media screen and (min-width: 1280px) {
        width: 23%;
    }
    @media screen and (max-width: 1279px) and (min-width: 960px) {
        width: 31.333333%;
    }
    @media screen and (max-width: 959px) and (min-width: 600px) {
        width: 48%;
    }
}
.cover {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    
    object-fit: cover;
}
</style>
